import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase"; // ajusta conforme necessário

async function snapDropdown(uid, modo, categoriaId, apostasPreenchidas) {
  if (!uid || !modo || !categoriaId || !apostasPreenchidas) {
    console.warn("❌ Dados incompletos para snapDropdown");
    return;
  }

  // Estrutura interna da categoria (com as posições)
  const estruturaCategoria = {};
  apostasPreenchidas.forEach((aposta, index) => {
    const pos = (index + 1).toString();
    estruturaCategoria[pos] = {
      titulo: aposta.titulo,
      imagem: aposta.imagem || "",
      ordem: index + 1,
      ...(aposta.filme && { filme: aposta.filme }),
      ...(aposta.pais && { pais: aposta.pais }),
      idInterno: aposta.idInterno || ""
    };
  });

  // Acrescenta a data de atualização (no nível da categoria)
  estruturaCategoria.dataAtualizacao = new Date().toISOString();

  // Estrutura final para merge no documento "dados"
  const dadosParaGravar = {
    [modo]: {
      [categoriaId]: estruturaCategoria
    }
  };

  // Caminho: usuarios/{uid}/snapDropdown2026/dados
  const ref = doc(db, "usuarios", uid, "snapDropdown2026", "dados");

  try {
    await setDoc(ref, dadosParaGravar, { merge: true });
    console.log("✅ snapDropdown gravado com sucesso");
  } catch (erro) {
    console.error("❌ Erro ao gravar snapDropdown:", erro);
  }
}

export default snapDropdown;